<!-- tags -->
<h2 class="mb-4">Tags Library</h2>
<p>
  Tags are a very powerful and flexible concept to group things in Client Hub. Tags can be used to group either Clients
  (tags can be applied to client workspaces) and / or Jobs (tags can be applied to jobs)
  <span class="mt-2 d-block">
    Examples: With Client Workspaces, you can create tags for “New Client”, “High-value Client”, “Long-time client” etc.
    and assign each clent the appropriate tags. Or another example can be to group clients by your team that works on
    that client. You can create tags for “Team A”, “Team B”, “Team C” etc. and then apply the tags to the clients that
    belong to that team. For tags on jobs, an example set of tags could be “Onboarding job”, “Payroll job” etc. Then,
    you can use these to filter your Jobs Dashboard to drill into just this type of job across all your clients.
  </span>
  <span class="mt-2 d-block">
    Below, you can add / remove the tags you would like to use in Client Hub.
  </span>
</p>
<div>
  <h4>Current tags</h4>
  <ch-tag *ngFor="let t of tags" [name]="t.name" [color]="t.color"
    (remove)="openRemoveTagModal(t, removeTagConfirmationModal)" (click)="editedTag = t; tag = t"
    [canRemove]="true"></ch-tag>
  <hr />
  <h4>{{ this.editedTag == null ? "Add new tags" : "Edit tag" }}</h4>
  <div class="row">
    <div class="col-sm-8 col-md-6 col-lg-4">
      <div class="practice-info-tag-management">
        <div class="d-flex align-items-center">
          <input class="form-control" type="text" name="name" [(ngModel)]="tag.name" placeholder="Tag name"
            style="margin-right: 8px; padding-left: 44px" />
          <button class="btn btn-primary" (click)="addTag()" *ngIf="editedTag == null">
            Add Tag
          </button>
          <button class="btn btn-primary" (click)="saveTag(editedTag)" *ngIf="editedTag != null">
            Save Tag
          </button>
          <button class="btn" (click)="editedTag = null; tag = { name: '', color: '' }" *ngIf="editedTag != null">
            Cancel
          </button>
        </div>
        <div class="tag-add-wrapper" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="true"
          style="position: relative; width: 0;">
          <div class="add-tag-color-icon" style="
                    position: relative;
                    margin-top: -34px;
                    margin-left: 5px;
                    width: 38px;
                  ">
            <i class="tio-color_picker_empty" style="
                      color: #fff;
                      position: absolute;
                      left: 7px;
                      top: 5px;
                      pointer-events: none;
                      font-size: 1.15rem;
                    "></i>
            <ch-tag [name]="" [color]="tag.color" tooltip="Pick a color" dropdownToggle></ch-tag>
          </div>

          <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu" role="menu"
            aria-labelledby="button-triggers-manual" style="width: 300px; left: 15px">
            <div class="tag-search-list" style="padding: 8px 16px">
              <div class="row" style="margin-bottom: -8px">
                <div class="col-sm-2" *ngFor="let color of tag_colors" style="padding: 0 6px">
                  <div class="tag-color-choose" style="
                            border-radius: 500px;
                            height: 32px;
                            margin-bottom: 8px;
                            cursor: pointer;
                          " [style]="{
                            background: color
                          }" (click)="selectColor(color)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Remove tag confirmation -->
<ng-template #removeTagConfirmationModal>
  <div class="modal-body rounded text-center">
    <h4>Are you sure?</h4>
    <p>
      Do you really want to remove this tag? it will be removed from all
      clients and jobs.
    </p>
    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-danger pull-left btn-block"
          (click)="removeTag(modalService.config.initialState._tag)">
          Remove
        </button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-default pull-right btn-block" (click)="modalRef.hide()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>